<i-modal
  [visible]="visible"
  [header]="{
    title: 'details.refusal-reason.title' | translate,
    closable: true,
  }"
  [modalParameters]="{ isModal: true, style: { width: '40vw' } }"
  [footer]="{ buttons: buttons }"
  (emitterOnVisibleChange)="cancel()"
>
  <div class="refusal-reason">
    @if (loading) {
      <div class="refusal-reason__loader">
        <i-loader></i-loader>
      </div>
    } @else {
      <label for="refusal-reason">
        {{ "details.refusal-reason.label" | translate }}
      </label>

      <textarea
        id="refusal-reason"
        pTextarea
        rows="5"
        [formControl]="reason"
        [placeholder]="'details.refusal-reason.placeholder' | translate"
      ></textarea>

      <div class="refusal-reason__footer">
        @if (reason.invalid) {
          <div class="refusal-reason__error">
            {{
              "details.refusal-reason.too-long" | translate: { max: maxLength }
            }}
          </div>
        }

        <div class="refusal-reason__counter">
          {{ reason.value.length }} / {{ maxLength }}
        </div>
      </div>
    }
  </div>
</i-modal>
